module.exports = __webpack_public_path__ + "img/payment_mb_04.a3d92281.png";